import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {Comportamento} from "../../../domain/Comportamento";

@Injectable()
export class ComportamentoHttpService extends AbstractHttpService<Comportamento>{
    url = '/api/comportamento';
}
